export function constructFAQSchema (schemaArray) {
  const entity = ({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer
    }
  })
  const entities =
    Array.isArray(schemaArray) &&
    schemaArray.map(({ question, answer }) => entity({ question, answer }))
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: entities
  }
  return JSON.stringify(baseSchema)
}
